import React from 'react';
import { select } from '@rematch/select'
import { connect } from 'react-redux';
import { Header } from 'semantic-ui-react'

class HelpComponent extends React.Component {

  render() {
    const { helpContent, helpContext } = this.props;

    return (
      <div>
        <Header size='tiny'>{helpContext}</Header>
        <div style={{ wordBreak: 'break-word' }} dangerouslySetInnerHTML={{ __html: helpContent }} />
      </div>
    )
  }
}


function mapStateToProps(state) {
  return {
    helpContext: state.app.helpContext,
    helpContent: select.app.getHelpContent(state)
  };
}

const connectedHelpComponent = connect(mapStateToProps)(HelpComponent);
export { connectedHelpComponent as HelpComponent };
